import {ActivatedRoute} from "@angular/router";
import {Component, ViewEncapsulation} from "@angular/core";
import {TitleService} from "../../services/title.service";
import {Viewing} from "../../models/tenant-find/viewing";
import {NgIf} from "@angular/common";

@Component({
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        NgIf
    ],
    templateUrl: './confirmed-viewing.page.html'
})
export class ConfirmedViewingPage {
    viewing: Viewing;

    constructor(
        private activatedRoute: ActivatedRoute,
        private titleService: TitleService) {
    }

    ngOnInit(){
        this.activatedRoute.data.subscribe(data => {
            this.viewing = data['viewing'];
            let pageTitle: string;
            if(this.viewing.roomSummary){
                pageTitle = `Viewing Confirmed - ${this.viewing.roomSummary.name}`;
            } else {
                pageTitle = `Viewing Confirmed - ${this.viewing.propertySummary.name}`;
            }
            this.titleService.setTitle([pageTitle]);
        });
    }
}

